<template>
  <div>
    <v-col v-if="searchBox" cols="12" id="searchBoxDiv">
      <SearchBox
        id="searchBox"
        @search="search = $event"
      />
    </v-col>
    <ListTwoLItemsSelect
      :items="computedClientes"
      itemTitle="nome_fantasia"
      itemSubtitle="razao_social"
      :fullscreen="true"
      :searchBox="searchBox"
      @clicked="$emit('clienteSelected', $event)"
    />
    <div class="my-3" id="listClientesPagination">
      <v-pagination
        v-model="page"
        :length="totalPages"
        circle
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SearchBox from '@/components/shared/SearchBox';
import ListTwoLItemsSelect from '@/components/shared/list/ListTwoLItemsSelect';
import { convertStringToCompare } from '@/helpers';

export default {
  name: 'ListClientesSelect',
  props: {
    searchBox: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    page: 1,
    order: 'nome_fantasia',
    search: '',
  }),
  components: {
    SearchBox,
    ListTwoLItemsSelect
  },
  computed: {
    ...mapGetters(['clientes']),
    computedClientes() {
      const start = (this.page - 1) * 10;
      const end = start + 10;
      let searchTerm = this.search || '';
      searchTerm = convertStringToCompare(searchTerm);
      return this.clientes
        .filter(cliente =>
          Object.keys(cliente)
            .some(key => convertStringToCompare(cliente[key]).includes(searchTerm || ''))
        )
        .slice(start, end)
        .sort((a, b) => a[this.order] > b[this.order] ? 1 : -1);
    },
    totalPages() {
      const total = this.clientes.length / 10;
      return total !== Infinity ? Math.ceil(total) : 0;
    }
  },
}
</script>

<style>

</style>